import React from "react";
import { NavLink } from "react-router-dom";
import "../blocks/sideBar/sideBar.css";

const SideBar = ({ userName, userAvatar, onEditProfile, onLogout }) => {
  return (
    <div className="sideBar__section">
      <div>
        <img
          src={userAvatar}
          className="sideBar__avatar"
          alt="avatar"
        />
      </div>
      <h3 className="sideBar__user-name">{userName}</h3>
      <nav className="sideBar__nav">
        <NavLink
          to="/profile"
          className={({ isActive }) =>
            `sideBar__nav-link${isActive ? " sideBar__nav-link_active" : ""}`
          }
        >
          My Closet
        </NavLink>
        <NavLink
          to="/favorites"
          className={({ isActive }) =>
            `sideBar__nav-link${isActive ? " sideBar__nav-link_active" : ""}`
          }
        >
          Favorites
        </NavLink>
        <NavLink
          to="/gallery"
          className={({ isActive }) =>
            `sideBar__nav-link${isActive ? " sideBar__nav-link_active" : ""}`
          }
        >
          Album
        </NavLink>
      </nav>
      <button
        type="button"
        className="sideBar__profile-button"
        onClick={onEditProfile}
      >
        Change profile data
      </button>
      <button
        type="button"
        className="sideBar__logout-button"
        onClick={onLogout}
      >
        Log out
      </button>
    </div>
  );
};

export default SideBar;
